import type { ReactNode, CSSProperties } from 'react';
import { colors } from './styles';

// Responsive table wrapper: overflow-x auto on mobile.

interface TableProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function TableWrapper({ children, style }: TableProps) {
  return (
    <div
      style={{
        border: `1px solid ${colors.border}`,
        borderRadius: '12px',
        overflow: 'hidden',
        background: colors.cardBg,
        ...style,
      }}
    >
      <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        {children}
      </div>
    </div>
  );
}

export const tableStyle: CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '0.85rem',
  minWidth: '600px',
};

export const theadStyle: CSSProperties = {
  background: colors.cardBgDark,
  textAlign: 'left',
};

export const thStyle: CSSProperties = {
  padding: '12px',
  color: colors.muted,
  fontWeight: 500,
};

export const trStyle: CSSProperties = {
  borderTop: `1px solid ${colors.borderSubtle}`,
};

export const tdStyle: CSSProperties = {
  padding: '12px',
};
